import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, radii, shadows } = theme

export const FormWrapper = styled.div`
  background-color: ${colors['neutral-background-default']};
  padding: ${space['spacing-sm']};
  border-radius: ${radii['corner-radius-md']};
  box-shadow: ${shadows['shadow-level-2']} #00000029;

  @media (${media.tablet}) {
    margin: ${space['spacing-md']} ${space['spacing-md']};
    padding: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    width: 80%;
    margin: ${space['spacing-xl']} ${space['spacing-xxl']};
    padding: ${space['spacing-lg']};
  }
`
